const initialState = {
  showSideBar: true
}

export const ACTION_TYPES = {
  SIDEBAR_SHOW: 'SIDEBAR_SHOW',
  SIDEBAR_HIDE: 'SIDEBAR_HIDE'
}

export const hideSideBar = () => ({
  type: ACTION_TYPES.SIDEBAR_HIDE
})

const content = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.SIDEBAR_SHOW:
      return {
        showSideBar: true
      }
    case ACTION_TYPES.SIDEBAR_HIDE:
      return {
        showSideBar: false
      }
    default:
      return state
  }
}

export default content
